<template>
  <!-- Mobile Footer -->
  <div 
    class="fixed bottom-0 left-0 w-full bg-white/90 backdrop-blur-md shadow-lg border-t border-gray-200 
           flex justify-between items-center px-6 py-3 z-50 md:hidden">

    <!-- Home -->
    <button aria-label="Action" class="flex flex-col items-center transition-all duration-200"
      :class="{'text-[#9134ea]': isActiveHome, 'text-gray-600 hover:text-[#9134ea]/80': !isActiveHome}"
      @click="$router.push('/')">
      <i class="fas fa-home text-lg"></i>
      <span class="text-xs mt-1 font-medium">Home</span>
    </button>

    <!-- Learn -->
    <button aria-label="Action" class="flex flex-col items-center transition-all duration-200"
      :class="{'text-[#9134ea]': isActiveLearn, 'text-gray-600 hover:text-[#9134ea]/80': !isActiveLearn}"
      @click="$router.push('/learn')">
      <i class="fas fa-book-open text-lg"></i>
      <span class="text-xs mt-1 font-medium">Learn</span>
    </button>

    <!-- Quiz -->
    <button aria-label="Action" class="flex flex-col items-center transition-all duration-200"
      :class="{'text-[#9134ea]': isActiveQuiz, 'text-gray-600 hover:text-[#9134ea]/80': !isActiveQuiz}"
      @click="$router.push('/quiz')">
      <i class="fa-solid fa-trophy text-lg"></i>
      <span class="text-xs mt-1 font-medium">Quizzes</span>
    </button>

    <!-- Community -->
    <button aria-label="Action" class="flex flex-col items-center transition-all duration-200"
      :class="{'text-[#9134ea]': isActiveCommunity, 'text-gray-600 hover:text-[#9134ea]/80': !isActiveCommunity}"
      @click="$router.push('/community')">
      <i class="fas fa-users text-lg"></i>
      <span class="text-xs mt-1 font-medium">Community</span>
    </button>

    <!-- Dashboard -->
    <button aria-label="Action" class="flex flex-col items-center transition-all duration-200"
      :class="{'text-[#9134ea]': isActiveDashboard, 'text-gray-600 hover:text-[#9134ea]/80': !isActiveDashboard}"
      @click="handleDashboardClick">
      <i class="fas fa-tachometer-alt text-lg"></i>
      <span class="text-xs mt-1 font-medium">Dashboard</span>
    </button>

  </div>
</template>

<script>
import { isUserAuthenticated } from '@/services/apiv2';

export default {
  name: 'MobileFooter',
  computed: {
    isActiveHome() {
      try {
        if (!this.$route) return false;
        const p = String(this.$route.path || '');
        return p === '/' || this.$route.name === 'Home' || p.startsWith('/home');
      } catch (e) { return false }
    },
    isActiveLearn() {
      try { return !!(this.$route && String(this.$route.path || '').startsWith('/learn')) } catch (e) { return false }
    },
    isActiveQuiz() {
      try { return !!(this.$route && String(this.$route.path || '').startsWith('/quiz')) } catch (e) { return false }
    },
    isActiveCommunity() {
      try { return !!(this.$route && String(this.$route.path || '').startsWith('/community')) } catch (e) { return false }
    },
    isActiveDashboard() {
      try { return !!(this.$route && String(this.$route.path || '').startsWith('/dashboard')) } catch (e) { return false }
    }
  },
  methods: {
    handleDashboardClick() {
      try {
        if (typeof isUserAuthenticated === 'function' && isUserAuthenticated()) {
          this.$router.push('/dashboard');
          return;
        }

        // If user is not authenticated, open the global login modal if available
        if (window.openLoginModal) {
          window.openLoginModal('Please login to access the dashboard');
          return;
        }

        // Fallback: emit an event so parent can handle opening login
        this.$emit('open-login', 'Please login to access the dashboard');
      } catch (err) {
        console.error('Error handling dashboard click:', err);
        // Safely attempt to open login modal as a fallback
        if (window.openLoginModal) window.openLoginModal('Please login to access the dashboard');
      }
    }
  }
}
</script>